import styles from "./FormInput.module.css";
import Select from "./Select";

const FormInput = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  type = "text",
  error,
  disabled = false,
  required = false,
  textarea = false,
  select = false,
  options = [],
  maxLength,
}) => {
  const controlClassName = [
    styles.control,
    error ? styles.errorControl : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={styles.field}>
      {label && (
        <label className={styles.label}>
          {label} {required && <span className={styles.required}>*</span>}
        </label>
      )}

      {textarea ? (
        <textarea
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          className={controlClassName}
        />
      ) : select ? (
        <Select
          name={name}
          value={value}
          onChange={onChange}
          disabled={disabled}
          placeholder={placeholder || "Select..."}
          options={options}
          error={error}
        />
      ) : (
        <input
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          maxLength={maxLength}
          className={controlClassName}
        />
      )}

      {error && <p className={styles.errorText}>{error}</p>}
    </div>
  );
};

export default FormInput;
